var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenPdf({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "picture_as_pdf"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9950_143517",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9950_143517)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "picture_as_pdf_2",
    d: "M5.76927 8.25642H6.28209V6.92308H7.10261C7.24876 6.92308 7.37077 6.87415 7.46864 6.77628C7.5665 6.67842 7.61542 6.55641 7.61542 6.41025V5.58975C7.61542 5.44359 7.5665 5.32158 7.46864 5.22372C7.37077 5.12585 7.24876 5.07692 7.10261 5.07692H5.76927V8.25642ZM6.28209 6.41025V5.58975H7.10261V6.41025H6.28209ZM8.30774 8.25642H9.58979C9.73595 8.25642 9.85795 8.20748 9.95581 8.10962C10.0537 8.01175 10.1026 7.88974 10.1026 7.74358V5.58975C10.1026 5.44359 10.0537 5.32158 9.95581 5.22372C9.85795 5.12585 9.73595 5.07692 9.58979 5.07692H8.30774V8.25642ZM8.82056 7.74358V5.58975H9.58979V7.74358H8.82056ZM10.9231 8.25642H11.4359V6.92308H12.359V6.41025H11.4359V5.58975H12.359V5.07692H10.9231V8.25642ZM5.41029 11.3333C5.10346 11.3333 4.84726 11.2306 4.64171 11.025C4.43615 10.8194 4.33337 10.5632 4.33337 10.2564V3.07692C4.33337 2.77008 4.43615 2.51389 4.64171 2.30833C4.84726 2.10278 5.10346 2 5.41029 2H12.5898C12.8966 2 13.1528 2.10278 13.3584 2.30833C13.5639 2.51389 13.6667 2.77008 13.6667 3.07692V10.2564C13.6667 10.5632 13.5639 10.8194 13.3584 11.025C13.1528 11.2306 12.8966 11.3333 12.5898 11.3333H5.41029ZM5.41029 10.6667H12.5898C12.6924 10.6667 12.7864 10.6239 12.8718 10.5385C12.9573 10.453 13 10.359 13 10.2564V3.07692C13 2.97436 12.9573 2.88034 12.8718 2.79487C12.7864 2.7094 12.6924 2.66667 12.5898 2.66667H5.41029C5.30773 2.66667 5.21372 2.7094 5.12824 2.79487C5.04277 2.88034 5.00004 2.97436 5.00004 3.07692V10.2564C5.00004 10.359 5.04277 10.453 5.12824 10.5385C5.21372 10.6239 5.30773 10.6667 5.41029 10.6667ZM3.41029 13.3333C3.10346 13.3333 2.84726 13.2306 2.64171 13.025C2.43615 12.8194 2.33337 12.5632 2.33337 12.2564V4.41025H3.00004V12.2564C3.00004 12.359 3.04277 12.453 3.12824 12.5385C3.21371 12.6239 3.30772 12.6667 3.41029 12.6667H11.2565V13.3333H3.41029Z",
    fill: "#595959"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenPdf);
export default __webpack_public_path__ + "static/media/openPDF.b27e3ccb87044943ac94bc237a687e1d.svg";
export { ForwardRef as ReactComponent };